<template>
  <v-menu
    v-model="menu"
    ref="userMenu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
    offset-y>

    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" v-bind:class="{ 'btn-pc-width': !isMobile }">
        <v-icon>mdi-account</v-icon>
        <span v-if="!isMobile" style="font-weight: bold; padding-top: auto; padding-bottom: auto;">
          ユーザー情報
        </span>
      </v-btn>
    </template>
    <v-card style="width:300px">
      <v-list>
        <v-list-item>
          <v-list-item-title>ユーザー情報</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>健康保険番号</v-list-item-subtitle>
            <v-list-item-title>{{this.userviewInfo.certificate_number}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>利用者区分</v-list-item-subtitle>
            <v-list-item-title>{{this.userviewInfo.user_classification}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              メールアドレス
              <v-btn @click="changeMail" x-small color="primary" outlined class="ml-3" v-bind:class="{ 'mobile-button': isMobile }">変更</v-btn>
            </v-list-item-subtitle>
            <v-list-item-title>
              {{this.userviewInfo.email}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn @click="signOut" color="primary">
              ログアウト
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { Auth } from 'aws-amplify'
import Theme from '../../utils/Theme'

export default {
  name: 'user',
  props: ['userviewInfo'],
  mixins: [Theme],
  data () {
    return {
      menu: false
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async mounted () {
    if (!this.getCampaign.id) {
      await this.$store.dispatch('initCampaign')
    }
  },
  methods: {
    changeMail () {
      this.$refs.userMenu.isActive = false
      this.$router.push('/email')
    },
    signOut () {
      try {
        Auth.signOut()
          .then(() => {
            this.$vuetify.theme.themes.light = this.$_getTheme(false)
            this.$store.dispatch('signOut')
            this.$router.push('/login')
          })
          .catch((e) => {
            this.$emit('errorHandling', 'サインアウトに失敗しました。' + e.errors[0].message)
            this.$log.debug(e)
          })
      } catch (e) {
        this.$emit('errorHandling', 'サインアウトに失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.btn-pc-width {
  width: 120px !important;
}
.mobile-button {
  margin-bottom: 2px;
}
</style>
